import React from "react";
import { useNavigate } from "react-router-dom";
import "./Itinerary.css";
import mirissaImg from "./miri.png";
import yalaImg from "./safari.jpg";
import unawatunaImg from "./beach.png";
import galleImg from "./galleFort.jpg";
import colomboImg from "./colombo.jpg";
import { useTranslation } from "./hooks/useTranslation";

const Package3Details = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBookNow = () => {
    navigate("/buy");
  };

  const packageInfo = {
    duration: t.package3Duration,
    charges: t.package3Charges,
    hotel: t.package3Hotel,
    price: t.package3Price
  };

  const locationsData = t.package3Locations || [];

  const locationImages = [
    { image: mirissaImg, alt: "Mirissa" },
    { image: yalaImg, alt: "Yala" },
    { image: unawatunaImg, alt: "Unawatuna" },
    { image: galleImg, alt: "Galle Fort" },
    { image: colomboImg, alt: "Colombo" }
  ];

  return (
    <div className="itinerary-wrapper">
      <header className="itinerary-header">
        <h1>{t.package3Title}</h1>
        <div className="package-info-section">
          <p className="intro-text">
            <strong>{packageInfo.duration}</strong>
          </p>
          <p className="intro-text">{packageInfo.charges}</p>
          <p className="intro-text">{packageInfo.hotel}</p>
          <p className="intro-text">
            <strong style={{ color: "#1a73e8", fontSize: "1.2rem" }}>
              {packageInfo.price}
            </strong>
          </p>
        </div>
      </header>

      {/* Book Now button above itinerary, right aligned */}
      <div className="book-now-wrapper top-right">
        <button className="book-now-button" onClick={handleBookNow}>
          {t.bookNow}
        </button>
      </div>

      <div className="itinerary-cards-container">
        {locationsData.map((location, index) => {
          const imageObj = locationImages[index] || {};
          return (
            <div key={index} className="itinerary-card">
              <div className="card-header">
                <div className="day-badge">{location.name}</div>
              </div>

              <div className="card-content">
                {imageObj.image && (
                  <img 
                    src={imageObj.image} 
                    alt={imageObj.alt || location.name} 
                    className="activity-image"
                  />
                )}
                <h3>{t.package3Activities}</h3>
                <div className="activity-details">
                  {location.activities.map((activity, i) => (
                    <div key={i} className="activity-item">
                      <h4 className="activity-title">{activity.title}</h4>
                      <p className="activity-desc">{activity.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Package3Details;

